document.addEventListener('DOMContentLoaded', function () {
  const popup = document.getElementById('search-popup');
  const input = document.getElementById('popup-search-input');
  const resultsBox = document.getElementById('popup-search-results');
  const openBtn = document.getElementById('open-search-popup');
  const closeBtn = document.getElementById('close-search-popup');

  const formatMoney = (cents) => window.theme.money.format(cents);
  const escapeHtml = (value) => String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');

  function open() {
    if (!popup) return;
    popup.classList.remove('hidden');
    input.value = '';
    resultsBox.innerHTML = '';
    input.focus();
  }

  function close() {
    popup?.classList.add('hidden');
  }

  /*
   * Published so a surface that hides the header can still reach the popup.
   * The Game HUD home screen is the case: the button this listener is bound to
   * is nowhere on the page.
   */
  window.themeSearchPopup = { open: open, close: close };

  openBtn?.addEventListener('click', open);
  closeBtn?.addEventListener('click', close);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      popup.classList.add('hidden');
    }
  });

  let fullResults = [];
  let searchRequestId = 0;
  let searchController;

  input?.addEventListener('input', function () {
    const query = input.value.trim();
    const requestId = ++searchRequestId;
    searchController?.abort();
    if (query.length < 2) {
      resultsBox.innerHTML = '';
      fullResults = [];
      return;
    }

    searchController = new AbortController();
    const signal = searchController.signal;

    fetch(`${window.theme.routes.search}/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product`, { signal })
      .then(res => {
        if (!res.ok) throw new Error('Search request failed');
        return res.json();
      })
      .then(data => {
        const baseProducts = data.resources.results.products || [];

        const fetchDetails = baseProducts.map(p =>
          fetch(`${window.theme.routes.root}products/${encodeURIComponent(p.handle)}.js`, { signal })
            .then(res => res.ok ? res.json() : null)
            .catch(error => {
              if (error.name === 'AbortError') throw error;
              return null;
            })
        );

        return Promise.all(fetchDetails).then(products => {
          if (requestId !== searchRequestId) return;
          fullResults = products.filter(p => p && p.variants?.length > 0);
          if (fullResults.length === 0) {
            resultsBox.innerHTML = `<div class="no-results">No valid products found</div>`;
            return;
          }

          renderResults(fullResults.slice(0, 6), query, true);
        });
      })
      .catch(error => {
        if (error.name === 'AbortError' || requestId !== searchRequestId) return;
        resultsBox.innerHTML = '<div class="no-results">Search is temporarily unavailable</div>';
      });
  });

  function renderResults(products, query, showAllLink = false) {
    resultsBox.innerHTML = products.map(product => {
      const variants = product.variants || [];
      const defaultVariantId = variants[0]?.id || '';
      const showVariantButtons = variants.length > 1 || (variants.length === 1 && variants[0].title !== 'Default Title');
      const productUrl = escapeHtml(product.url);
      const productTitle = escapeHtml(product.title);
      const productImage = product.featured_image ? window.ThemeProductImages.create(product.featured_image, { sizes: '60px', cap: 240, alt: product.title }).outerHTML : '';

      const variantButtons = showVariantButtons
        ? variants.map((variant, idx) => `
            <button type="button" class="variant-btn${idx === 0 ? ' selected' : ''}" data-variant-id="${escapeHtml(variant.id)}" data-variant-price="${escapeHtml(variant.price)}">
              ${escapeHtml(variant.title)}
            </button>
          `).join('')
        : '';

      return `
        <div class="popup-search-item">
          <div class="popup-search-item-inner">
            <a href="${productUrl}" class="popup-image-link">
              ${productImage}
            </a>
            <div class="popup-product-info">
              <a href="${productUrl}">
                <div class="popup-title">${productTitle}</div>
                <div class="popup-price">${formatMoney(variants[0]?.price ?? product.price)}</div>
              </a>
              ${showVariantButtons ? `
                <div class="popup-variants">
                  ${variantButtons}
                  <form class="popup-cart-form" method="post" action="${window.theme.routes.cartAdd}">
                    <input type="hidden" name="id" value="${escapeHtml(defaultVariantId)}">
                    <button type="submit" class="add-to-cart-btn">Add</button>
                    <span class="added-msg" style="display:none;">✔ Added</span>
                  </form>
                </div>
              ` : ''}
            </div>
          </div>
        </div>
      `;
    }).join('');

    if (showAllLink && fullResults.length > 6) {
      resultsBox.innerHTML += `
        <div class="popup-show-all">
          <a href="#" id="show-all-link">Show all (${fullResults.length}) results for '${escapeHtml(query)}'</a>
        </div>
      `;

      document.getElementById('show-all-link')?.addEventListener('click', function (e) {
        e.preventDefault();
        renderResults(fullResults, query, false);
      });
    }

    attachVariantButtons();

  }

  function attachVariantButtons() {
    document.querySelectorAll('.variant-btn').forEach(button => {
      button.addEventListener('click', function () {
        const variantId = this.dataset.variantId;
        const item = this.closest('.popup-search-item');
        item.querySelector('form input[name="id"]').value = variantId;

        // Variants can be priced differently, so the shopper must not be shown
        // the first variant's price while a second one is queued to add.
        const price = item.querySelector('.popup-price');
        if (price && this.dataset.variantPrice) {
          price.textContent = formatMoney(this.dataset.variantPrice);
        }

        const all = this.parentElement.querySelectorAll('.variant-btn');
        all.forEach(btn => btn.classList.remove('selected'));
        this.classList.add('selected');
      });
    });
  }

});
